const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['出勤', 'Attendance hours', '出勤'],
				children: {
					ZZ_COMMON_AM10010: {
						name: ['出勤模擬試算', 'Attendance Simulation', '出勤模拟试算'],
						url: '/zz_common_am10010',
						hint: [],
					},
					ZZ_UCCAPITAL_AM10010: {
						name: ['(客製)扣特休特殊假勤設定', '(客製)扣特休特殊假勤設定', '(客製)扣特休特殊假勤設定'],
						url: '/zz_uccapital_am10010',
						hint: [],
					},
					ZZ_UCCAPITAL_AM10020: {
						name: ['(客製)特殊假扣抵明細', '(客製)特殊假扣抵明細', '(客製)特殊假扣抵明細'],
						url: '/zz_uccapital_am10020',
						hint: [],
					},
					ZZ_UCCAPITAL_AM10030: {
						name: ['(客製)請假明細發送通知', '(客製)請假明細發送通知', '(客製)請假明細發送通知'],
						url: '/zz_uccapital_am10030',
						hint: [],
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};